import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const Fieldset = ui.S9Fieldset.default;
const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const PartnerForm = ({ schema }: Props) => {
  const fields = [
    {
      field: 'registered_name',
    },
    {
      field: 'trade_as_name',
      colSize: 12,
    },
    {
      field: 'registered_number',
      colSize: 12,
    },
    {
      field: 'address_line_1',
      colSize: 12,
    },
    {
      field: 'address_line_2',
      colSize: 12,
    },
    {
      field: 'suburb',
      colSize: 6,
    },
    {
      field: 'post_code',
      colSize: 6,
    },
    {
      field: 'state',
      colSize: 6,
    },
    {
      field: 'country',
      colSize: 6,
    },
    {
      field: 'is_active',
      colSize: 8,
    },
    {
      field: 'logo',
      colSize: 8,
    },
  ];

  return (
    <S9PageSection title="Partner details" size="sm">
      {schema && (
        <Fieldset
          context={{ id: undefined }}
          schema={schema}
          formFields={fields}
        />
      )}
    </S9PageSection>
  );
};

export default PartnerForm;
